(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    (window.batteryPackConfig || []).forEach(setupInstance);
  }

  function setupInstance(config) {
    var root = document.querySelector(config.rootSelector);
    if (!root) return;

    if (!window.ProductAddonsCore) {
      console.error('battery-pack-addon: ProductAddonsCore not found — make sure product-addons-core.js loads first');
      return;
    }

    var chipGroup = root.querySelector('[data-battery-pack-chip-group]');
    var errorEl = root.querySelector('[data-battery-pack-error]');
    var variants = config.variants || [];
    var selectedSkus = {}; // sku -> true, nothing selected by default

    if (!variants.length) {
      showError('Battery pack add-on is not configured correctly. Contact support.');
      console.error('battery-pack-addon: no variants resolved — check the addon_handle in product-form.liquid, or the custom.battery_pack_options metafield on this product');
      window.ProductAddonsCore.register(root, function () {
        showError('Battery pack add-on is not configured correctly. Contact support.');
        return { ok: false };
      });
      return;
    }

    renderChips();
    window.ProductAddonsCore.register(root, getContribution, getPriceContribution);

    function renderChips() {
      chipGroup.innerHTML = '';
      variants.forEach(function (variant) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'product__chip';
        chip.dataset.sku = variant.sku;
        chip.setAttribute('aria-pressed', 'false');
        chip.textContent = chipLabel(variant);
        chip.addEventListener('click', function () {
          var isNowSelected = !selectedSkus[variant.sku];
          if (isNowSelected) {
            selectedSkus[variant.sku] = true;
          } else {
            delete selectedSkus[variant.sku];
          }
          chip.classList.toggle('selected', isNowSelected);
          chip.setAttribute('aria-pressed', isNowSelected ? 'true' : 'false');
          clearError();
          if (window.ProductAddonsCore.notifyChange) window.ProductAddonsCore.notifyChange(root);
        });
        chipGroup.appendChild(chip);
      });
    }

    // Live price preview only — no validation, no error UI.
    function getPriceContribution() {
      var total = 0;
      variants.forEach(function (v) {
        if (selectedSkus[v.sku]) total += Number(v.price);
      });
      return total;
    }

    function chipLabel(variant) {
      var name = (variant.label && variant.label !== 'Default Title') ? variant.label : variant.sku;
      return name + ' (+' + formatMoney(variant.price) + ')';
    }

    // Called by ProductAddonsCore when the shopper clicks add-to-cart.
    // Always ok: this option is entirely optional, zero selections is valid.
    function getContribution() {
      var items = variants
        .filter(function (v) { return selectedSkus[v.sku]; })
        .map(function (v) {
          return {
            id: v.variantId,
            quantity: 1,
            properties: { 'Battery Pack': v.label || v.sku }
          };
        });

      clearError();
      return { ok: true, items: items };
    }

    function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function clearError() { errorEl.textContent = ''; errorEl.hidden = true; }
    function formatMoney(amount) { return '$' + Number(amount).toFixed(2); }
  }
})();